import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef, QueryList, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ForgetPasswordService } from '../../../Services/Password/forget-password.service';
import { NotificationService } from '../../../Services/notification.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-verify-otp',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.css']
})
export class VerifyOtpComponent implements OnInit, AfterViewInit {
  router = inject(Router);
  fb = inject(FormBuilder);
  forgotPasswordService = inject(ForgetPasswordService);
  notificationService = inject(NotificationService);

  forgotPasswordForm!: FormGroup;
  emailFromState: string = '';
  isLoading: boolean = false;
  isResending: boolean = false;

  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  ngOnInit(): void {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as { email: string };
    this.emailFromState = state?.email || localStorage.getItem('reset_email') || '';

    this.forgotPasswordForm = this.fb.group({
      email: [this.emailFromState, [Validators.required, Validators.email]],
      d1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d4: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d5: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d6: ['', [Validators.required, Validators.pattern('[0-9]')]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      password_confirmation: ['', [Validators.required]]
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.otpInputs?.first?.nativeElement?.focus();
    }, 100);
  }

  handleOtpInput(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9]/g, ''); // Only numbers

    input.value = value;
    const otpArray = this.otpInputs.toArray();

    if (value && index < otpArray.length - 1) {
      otpArray[index + 1].nativeElement.focus();
    } else if (!value && event.key === 'Backspace' && index > 0) {
      otpArray[index - 1].nativeElement.focus();
    }

    const controlName = `d${index + 1}`;
    this.forgotPasswordForm.get(controlName)?.setValue(value);
  }

  verifyOtp() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      this.notificationService.showError('Please enter the 6-digit OTP and set your new password.', 'Validation Error');
      return;
    }

    const val = this.forgotPasswordForm.value;
    if (val.password !== val.password_confirmation) {
      this.notificationService.showError('Passwords do not match.', 'Validation Error');
      return;
    }

    const otp = `${val.d1}${val.d2}${val.d3}${val.d4}${val.d5}${val.d6}`;

    const payload = {
      email: val.email,
      otp: otp,
      password: val.password,
      password_confirmation: val.password_confirmation
    };

    this.isLoading = true;

    this.forgotPasswordService.resetPassword(payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.notificationService.showSuccess('Password updated successfully! Please log in.', 'Success');
        localStorage.removeItem('reset_email');
        this.router.navigate(['login']);
      },
      error: (err) => {
        this.isLoading = false;
        this.notificationService.showError(
          err?.error?.message || 'Invalid OTP. Please try again.',
          'Error'
        );
      }
    });
  }

  resendOtp() {
    if (!this.emailFromState) {
      this.notificationService.showError('Email address is missing. Please go back and request OTP again.', 'Error');
      return;
    }

    this.isResending = true;
    this.forgotPasswordService.forgotPassword({ email: this.emailFromState }).subscribe({
      next: (res: any) => {
        this.isResending = false;
        this.notificationService.showSuccess(res?.message || 'OTP resent successfully!', 'Success');
      },
      error: (err: any) => {
        this.isResending = false;
        this.notificationService.showError(err?.error?.message || 'Failed to resend OTP.', 'Error');
      }
    });
  }
}

